import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

import { constructPagePath } from 'utils/localeRouteGuide';

import localize from 'components/Localize/Localize';

import styles from './FooterNav.css';
import translations from './translations';

const cx = classNames.bind(styles);

export const FooterNav = (props) => {
  const getPrevIndex = () => {
    const prevIndex = props.selectedLinkIndex - 1;
    const lastIndex = props.links.length - 1;

    return (prevIndex < 0) ? lastIndex : prevIndex;
  };

  const getNextIndex = () => {
    const nextIndex = props.selectedLinkIndex + 1;
    const lastIndex = props.links.length - 1;

    return (nextIndex > lastIndex) ? 0 : nextIndex;
  };

  const renderButton = (action) => {
    const index = action === `prev` ? getPrevIndex() : getNextIndex();
    const link = props.links[index];
    const btnModifier = action;

    return (
      <Link
        className={cx(`item`, `item--${btnModifier}`)}
        to={constructPagePath(props.locale, link.link)}
      >
        <div className={styles[`item-content`]}>
          <img
            alt={link.linkText}
            className={styles[`item-arrow`]}
            src={`/assets-spa/images/arrow-right.svg`}
          />
          <div className={styles[`item-text`]}>
            <div className={styles[`item-title`]}>{props.t[btnModifier]}</div>
            <div className={styles[`item-section`]}>{link.linkText}</div>
          </div>
        </div>
      </Link>
    );
  };

  return (
    <nav className={styles[`container`]}>
      <div className={styles[`inner`]}>
        {renderButton(`prev`)}
        {renderButton(`next`)}
      </div>
    </nav>
  );
};

FooterNav.propTypes = {
  links: PropTypes.array,
  locale: PropTypes.string.isRequired,
  selectedLinkIndex: PropTypes.number,
  t: PropTypes.shape({
    next: PropTypes.string,
    prev: PropTypes.string,
  }),
};

export default localize(FooterNav, translations);
